module.exports = __webpack_public_path__ + "static/media/mondelez.a14c48ce.svg";